import React, { Fragment, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import config from '../../config';
function ModalCompanyModules({ company_name, company_code }) {
  const [show, setShow] = useState(false);
  const [modules, setModules] = useState([]);
  const [isloading, setIsLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateList = (e) => {
    const moduleUpdate = modules.map((element) => {
      if (e.NOMBRE_GRUPO_MODULO === element.NOMBRE_GRUPO_MODULO) element.ACTIVO = !element.ACTIVO
      return element
    })
    setModules(moduleUpdate);
  }

  const saveChange = () => {
    setIsLoading(true)
    const datasend = {
      method: 'POST',
      body: JSON.stringify({
        modules: modules,
      }),
      headers: {
        'Content-Type': 'application/json',
        'empresa': company_code
      }
    };
    fetch(config.servBackEnd + '/modules/companygroupmodule/', datasend).then(response => response.json())
      .then(data => {
        if (data.ok) {
          handleClose();
          setIsLoading(false);
        } else {
          console.log(data.message);
          setIsLoading(false)
        }
      });
  }

  useEffect(() => {
    if (show) {
      const datasend = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': company_code
        }
      };
      fetch(config.servBackEnd + '/modules/groupmodule/', datasend).then(response => response.json())
        .then(data => {
          if (data.ok) {
            const datos = data.data;
            setModules(datos);
          } else {
            console.log(data.message);
          }
        });
    }
  }, [show])

  return (
    <Fragment>
      <Button variant="outline-primary" onClick={handleShow}>
        Modificar Permisos
      </Button>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{company_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="grid-container">
            {modules.map((element, index) => (
              <div key={index} className="grid-item" onClick={() => updateList(element)}>
                <Form.Check // prettier-ignore
                  type='checkbox'
                  name={element.ID}
                  checked={element.ACTIVO}
                  label={element.NOMBRE_GRUPO_MODULO}
                  readOnly
                />
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {isloading
            ? <Spinner animation="border" />
            : <Fragment>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={saveChange}>
                Save Changes
              </Button>
            </Fragment>
          }
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default ModalCompanyModules;


// WEBPACK FOOTER //
// ./src/components/subcomponent/companyModuleModal.jsx